export default function(apiKey, user) {
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer',`${apiKey}`);

    window.dataLayer = window.dataLayer || [];

    const gtmData = {
        'user_id' : user.info.user_id,
        'master_user_id': user.info.master_user_id,
        'type_id' : user.info.type_id,
        'role_id' : user.info.role_id,
        'created_at' : user.info.created_at,
        'timezone_name' : user.info.timezone_name,
        'user_sku' : user.info.user_sku,
        'account_id' : user.info.org_id,
        'account_name' : user.info.org_name,
        'is_spoofed' : user.info.user_id !== user.info.master_user_id
    };

    dataLayer.push(gtmData);
};
